window.duo.validation = {};
window.duo.validation.forms = {};
window.duo.validation.prevents = [];
window.duo.validation.hardPrevents = [];

window.duo.validation.registerFields = (validatable, queries = {}, options = {}) => {

	//
	// Autovalidate only if the validation on load property is set
	options.autoValidation = options.autoValidation || document.querySelector('[validation-on-load]') !== null;

	for (let query in queries) {
		const node = document.querySelector(query);
		if (node === null) {
			continue;
		}

		//
		// Retrieve the actual field name for the form field
		const name = queries[query];

		let event = {
			trigger:	'input',
			query:		query
		}

		if (node.tagName == 'INPUT') {
			if (node.type == 'checkbox') {
				event.trigger = 'change';
			}

			if (node.type == 'radio') {
				event.trigger = 'click';
			}
		}

		if (node.tagName == 'SELECT') {
			event.trigger = 'change';
		}

		if (!window.duo.validation.forms.hasOwnProperty(validatable))
		{
			window.duo.validation.forms[validatable] = {
				beforeHook:	options.before || (() => {}),
				afterHook:	options.after || (() => {}),
				fields:		{},
				meta:		options.meta || {}
			};
		}

		window.duo.validation.forms[validatable].fields[query] = { node, name, event };

		$(document).on(event.trigger, event.query, () => {

			//
			// If the "autoValidation" property is set and has the value "true"
			// the fields are going to validate as soon as the event triggers it
			if (options.hasOwnProperty('autoValidation') && options.autoValidation) {
				window.duo.validation.request(validatable);
			}

			if (options.hasOwnProperty('onFieldValueChange')) {
				options.onFieldValueChange(node, name, window.duo.fieldValue(node, true));
			}
		});
	}

	//
	// Immediately validate the form when available (and autoValidation is on)
	// The validation-on-load attribute must be on some node
	if (options.hasOwnProperty('autoValidation') && options.autoValidation) {
		if (!!document.querySelector(`[validation-on-load="${ validatable }"]`)) {
			window.duo.validation.request(validatable);
		}
	}
};

window.duo.validation.request = (validatable) => {
	const shouldHardPreventValidation = window.duo.validation.hardPrevents.includes(validatable);
	if (shouldHardPreventValidation) {
		return;
	}

	const shouldPreventValidation = window.duo.validation.prevents.includes(validatable);

	//
	// Determine whether the validatable validates a modal in a study form
	const isStudyTable = validatable.substr(0, 7) == 'table::';

	const meta = window.duo.validation.forms[validatable].meta
	let processedMeta = {}
	for (let key in meta) {
		const keydata = meta[key];
		if (typeof keydata == 'function') {
			processedMeta[key] = keydata();
		} else {
			processedMeta[key] = keydata;
		}
	}

	let namePrefix = processedMeta.hasOwnProperty('namePrefix') ? processedMeta['namePrefix'] : null;

	let data = {};
	for (let query in window.duo.validation.forms[validatable].fields) {
		const field = window.duo.validation.forms[validatable].fields[query];
		const name = namePrefix ? namePrefix + '_' + field.name : field.name;
		data[name] = window.duo.fieldValue(field.node);
	}

	window.duo.validation.forms[validatable].beforeHook(data);
	$.post(route('post-validation'), { validatable, data, meta }, result => {
		let resultInvalid = false;

		for (let name in result.fields) {
			let fieldName = name;
			const registeredKeys = Object.keys(window.duo.validation.forms[validatable].fields);

			if (isStudyTable) {

                //
                // It is unclear, why this code is being executed.
                // It checks if the current field name exists in the registered keys array
                // even if a following underscore and then uses this found key:
                //
                // fieldName = table_psa
                // -> searches for keys beginning with "table_psa_"
                // -> finds for example "table_psa_unit" and then using this as the current fieldName
                // -> This results in "table_psa" error messages never being rendered, since its overwritten with another key name
                //
                // To fix this with the least effect on the current code the overwrite is skipped
                // when the found key is also another valid result key
                const resultKeys = Object.keys(result.fields);
				registeredKeys.forEach(key => {

                    //
                    // Note: This is probably due to checklist items where each option has a single registeredKey
                    // for example a checklist with unique id "weekdays" and items "monday", "tuesday" and so on
                    // won't have a "weekdays" registered key, however "weekdays_monday" and "weekdays_tuesday" will
                    // have their own registered key. On the other hand – for validation – the result key will be
                    // "weekday" (a per element validation). Thus if the script finds "weekdays_..." it assumes that this
                    // option belongs to a checklist. The "resultKeys.inclludes" check prioritizes full elements over
                    // checklist items
					if (key.startsWith(`[name="${ fieldName }_`)) {
                        const overwriteKey = key.substring(7, key.length - 2);
                        if (! resultKeys.includes(overwriteKey)) {
                            fieldName = overwriteKey;
                        }
					}
				});
			} else {
				if (registeredKeys.includes(`[name="${ fieldName }[]"]`)) {
					fieldName = `${ fieldName }[]`;
				}
			}

			const data		= result.fields[name];
			const valid		= shouldPreventValidation ? true : data.identifier == 'success';
			const invalid	= shouldPreventValidation ? false : data.identifier == 'danger' || data.identifier == 'warning';
			const fields	= $(`[name="${ fieldName }"]`);
			const group		= fields.closest('[validates]');

			resultInvalid = resultInvalid || data.identifier == 'danger'

			let statusNode	= $(`[validation-status="${ fieldName }"]`);
			let messageNode	= $(`[validation-message="${ fieldName }"]`);

			if (statusNode.length == 0) {
				statusNode = group.find('[validation-status]');
			}

			if (messageNode.length == 0) {
				messageNode = group.find('[validation-message]');
			}

			statusNode.html(valid ? null : data.render);
			messageNode.html(invalid ? data.message : null);

			fields.each((index, field) => {
				field.classList.remove('is-invalid');
				field.classList.remove('is-invalid-warning');
				field.classList.remove('is-invalid-info');
				if (invalid) {
					$(field).addClass(data.class);
				}
			});
		}

		$('[data-toggle="tooltip"]').tooltip();
		window.duo.validation.forms[validatable].afterHook({
			invalid: resultInvalid,
			valid: !resultInvalid
		});
	});
};

window.duo.validation.requestNow = (validatable, data, afterHook = () => {}, meta = {}) => {

	let processedMeta = {}
	for (let key in meta) {
		const keydata = meta[key];
		if (typeof keydata == 'function') {
			processedMeta[key] = keydata();
		} else {
			processedMeta[key] = keydata;
		}
	}

	$.post(route('post-validation'), { validatable, data, meta }, result => {
		afterHook(result);
	});
};

window.duo.validation.preventValidation = (validatable, prevent) => {
	if (prevent && !window.duo.validation.prevents.includes(validatable)) {
		window.duo.validation.prevents.push(validatable);
	}

	if (!prevent && window.duo.validation.prevents.includes(validatable)) {
		const index = window.duo.validation.prevents.indexOf(validatable);
		window.duo.validation.prevents.splice(index, 1);
	}
}


window.duo.validation.hardPreventValidation = (validatable, prevent) => {
	if (prevent && !window.duo.validation.hardPrevents.includes(validatable)) {
		window.duo.validation.hardPrevents.push(validatable);
	}

	if (!prevent && window.duo.validation.hardPrevents.includes(validatable)) {
		const index = window.duo.validation.hardPrevents.indexOf(validatable);
		window.duo.validation.hardPrevents.splice(index, 1);
	}
}
